import { useEffect, useState } from "react";
import type { ActionEntitlement } from "./entitlement-policy";

const remaining = (value?: string): string | undefined => {
  if (!value) return undefined;
  const seconds = Math.max(0, Math.ceil((new Date(value).getTime() - Date.now()) / 1_000));
  const days = Math.floor(seconds / 86_400);
  const hours = Math.floor((seconds % 86_400) / 3_600);
  const minutes = Math.floor((seconds % 3_600) / 60);
  return days ? `${days}d ${hours}h` : `${hours}h ${minutes}m`;
};

export const useEntitlementCta = (gate: ActionEntitlement): { label: string; href: string; detail?: string } | null => {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!gate.nextGrantAt) return;
    const timer = window.setInterval(() => tick((value) => value + 1), 60_000);
    return () => window.clearInterval(timer);
  }, [gate.nextGrantAt]);
  if (gate.cta === "manage_trial") return { label: "Manage Nikola's Trial", href: "/subscription#trial" };
  if (gate.cta === "join_club") return { label: "Join Club", href: "/subscription" };
  if (gate.cta === "add_credits")
    return {
      label: "Add Credits",
      href: "/subscription?credits=1",
      detail: gate.nextGrantAt ? `750 more in ${remaining(gate.nextGrantAt)}` : undefined,
    };
  return null;
};
